import { FC } from "react";
import clsx from "clsx";
import Stack from "@mui/material/Stack";
import { Rating, SvgIcon } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { styled } from "@mui/material/styles";
import styles from "./AnalystInfo.module.scss";
import { useTranslation } from "next-i18next";

interface AnalystInfoCardProps {
    name: string;
    company: string;
    rating: number;
    avatar: string | null;
    theme?: "dark" | "light";
}

const GradientStarIcon = (props: any) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <defs>
            <linearGradient id="starGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#D1B37E" />
                <stop offset="100%" stopColor="#806E50" />
            </linearGradient>
        </defs>
        <path
            fill="url(#starGradient)"
            d="M12 17.27L18.18 21 16.54 13.97 22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
        />
    </SvgIcon>
);

const StyledRating = styled(Rating)(({ theme }) => ({
    "& .MuiRating-iconFilled": {
        color: "transparent", // важно: svg сам окрашен градиентом
    },
    "& .MuiRating-iconEmpty": {
        color: theme.palette.mode === "dark" ? "#89909c" : "#ccc",
    },
}));

export const AnalystInfo: FC<AnalystInfoCardProps> = ({ name, company, rating, theme, avatar }) => {
    const { t } = useTranslation("common");
    return (
        <div className={styles.card}>
            <div className={styles.logo}>
                <img
                    src={avatar || "/images/analytics/analyst.png"}
                    alt={t("analytics.analystForecasts.analystInfo.avatarAlt")}
                    width={54}
                    height={54}
                />
            </div>
            <div className={styles.info}>
                <span
                    className={clsx(styles.name, {
                        [styles[theme]]: !!theme,
                    })}>
                    {name}
                </span>
                <span
                    className={clsx(styles.company, {
                        [styles[theme]]: !!theme,
                    })}>
                    {company}
                </span>
                <div
                    className={styles.rating}
                    title={t("analytics.analystForecasts.analystInfo.ratingLabel", { rating })}
                >
                    <Stack spacing={1}>
                        <StyledRating
                            name="analyst-rating"
                            defaultValue={rating}
                            value={rating}
                            precision={0.1}
                            readOnly
                            icon={<GradientStarIcon fontSize="inherit" />}
                            emptyIcon={<StarIcon fontSize="inherit" />}
                        />
                    </Stack>
                </div>
            </div>
        </div>
    );
};
